import Order from '../../models/Order';

export interface OrderRevisionPollResult {
    appOrderId: number | null;
    revision: string | null;
    orderState: number | null;
}

export interface OrderRevisionPollResponse {
    appOrderId?: number;
    AppOrderId?: number;
    revision?: string;
    Revision?: string;
    orderState?: number;
    OrderState?: number;
}

export const getExpectedRevision = (order?: Order): number | null => {
    if (!order || !order.orderheader) {
        return null;
    }

    const header = order.orderheader;
    const revision = header.revision != null ? header.revision : header.Revision;

    if (revision == null || revision === '') {
        return null;
    }

    const parsed = typeof revision === 'number' ? revision : parseInt(String(revision), 10);
    return Number.isNaN(parsed) ? null : parsed;
};

export const readRevisionFromOrder = (order?: Order): string | null => {
    const revision = getExpectedRevision(order);
    return revision != null ? String(revision) : null;
};

export const readRevisionFromApiValue = (value: string | number | null | undefined): number | null => {
    if (value == null || value === '') {
        return null;
    }

    const parsed = typeof value === 'number' ? value : parseInt(String(value), 10);
    return Number.isNaN(parsed) ? null : parsed;
};

export const parseOrderRevisionPollResult = (
    data: OrderRevisionPollResponse | null | undefined
): OrderRevisionPollResult => {
    if (!data) {
        return { appOrderId: null, revision: null, orderState: null };
    }

    const appOrderId = data.appOrderId != null ? data.appOrderId : data.AppOrderId;
    const revision = data.revision != null ? data.revision : data.Revision;
    const orderStateRaw = data.orderState != null ? data.orderState : data.OrderState;

    return {
        appOrderId: appOrderId != null ? appOrderId : null,
        revision: revision != null && revision !== '' ? String(revision) : null,
        orderState: orderStateRaw != null ? orderStateRaw : null,
    };
};

export const isOrderEditableFromPoll = (orderState: number | null | undefined): boolean =>
    orderState == null || orderState === 0;

export const isOrderLockedFromPoll = (orderState: number | null | undefined): boolean =>
    !isOrderEditableFromPoll(orderState);
